/**
 * `account_switch.error` — the console's half of NFR12-09's "account-switch errors" (plan-014 A4,
 * design §27.16).
 *
 * The browser has no metrics exporter, so every failed switch (refused, stale, a stricter destination,
 * a network fault) is counted here and announced as a DOM event on `globalThis` with only a stable
 * code — never an organization, a workspace, a person or a message — for whatever collects browser
 * telemetry to subscribe to. The server counts its own half: every `409 scope_changed` it answers.
 */
import { ApiError } from "@wetalk/api-client";

export const ACCOUNT_SWITCH_ERROR_EVENT = "wetalk:account_switch.error";

let errorCount = 0;

/** How many switches failed in this tab since it opened. */
export function accountSwitchErrorCount(): number {
  return errorCount;
}

/** The stable code a failure is counted under: the API's error code, else its kind. */
export function accountSwitchErrorCodeOf(raised: unknown): string {
  if (raised instanceof ApiError) return raised.code;
  if (raised instanceof Error) return raised.name;
  return "unknown";
}

export function recordAccountSwitchError(raised: unknown): void {
  errorCount += 1;
  const code = accountSwitchErrorCodeOf(raised);
  if (typeof globalThis.dispatchEvent === "function" && typeof globalThis.CustomEvent === "function") {
    globalThis.dispatchEvent(new globalThis.CustomEvent(ACCOUNT_SWITCH_ERROR_EVENT, { detail: { code } }));
  }
}
